var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumbs"},_vm._l((_vm.breadcrumbsLinks),function(link,i){return _c('div',{key:`brdcrmbs-${ i }`,staticClass:"breadcrumbs_level",domProps:{"innerHTML":_vm._s(link.name + _vm.getSlash(i))},on:{"click":function($event){_vm.goToRoute(link.path, (link.prevent) ? link.prevent : false)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }